import axios from 'axios';

export default axios.create({
    baseURL: 'https://docs.google.com/spreadsheets/d/'
});